import { useCallback, useRef } from 'react';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

import ResponsiveImage from '../../atoms/responsive-image/responsive-image';
import { autoplayProps } from '../../../config/carousel';
import * as S from '../banner-carousel/styles';

type CarouselProps = {
  name: string;
  imageURLs: string[];
};

export function Carousel(props: CarouselProps) {
  const { imageURLs, name } = props;

  const sliderRef = useRef() as any;

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const navigation = (
    <div className="text-header4 text-slate-800 font-light">
      <BsChevronLeft
        className="absolute top-2/4 -translate-y-2/4 left-2 lg:left-14 z-50 hover:text-black cursor-pointer"
        onClick={handlePrev}
      />
      <BsChevronRight
        className="absolute right-2 lg:right-14 top-2/4 -translate-y-2/4 z-50 hover:text-black cursor-pointer"
        onClick={handleNext}
      />
    </div>
  );

  const slides = imageURLs.map((imageURL, index) => {
    return (
      <SwiperSlide key={`${name}-carousel-slide-${index}`}>
        <div className="relative">
          <div className="hidden sm:block">{navigation}</div>
          <ResponsiveImage
            priority
            alt="carousel image"
            blurImageSrc="/icons/blur-placeholder.png"
            dimensions="w-full h-112 lg:h-[calc(100vh-87px)]"
            objectFit="cover"
            src={imageURL}
          />
        </div>
      </SwiperSlide>
    );
  });

  return (
    <S.SwiperContainer>
      <Swiper
        autoplay={autoplayProps}
        className="mySwiper"
        loop={true}
        modules={[Autoplay, Navigation]}
        onInit={(core: SwiperCore) => {
          sliderRef.current = core.el;
        }}
        pagination={{ clickable: true }}
        speed={900}
      >
        {slides}
      </Swiper>
    </S.SwiperContainer>
  );
}

export default Carousel;
